import { IRouterInfo } from '@/coreDomainsModule/entities/routerInfo';
import { i18n } from '@/i18n';
import { Component } from 'vue';
import SupplierForecastDashboard from './pages/SupplierForecastDashboard.vue';
import AllBusinessesForSupplierForecast from './pages/AllBusinessesForSupplierForecast.vue';
import { ISupplierForecastExportData } from './domains/entities/supplierForecastExportData';

const t = i18n.t;

export const SUPPLIER_TAB_ROUTER_INFO: ReadonlyArray<Readonly<IRouterInfo & { component: Component }>> = [
  {
    router: '/supplier',
    name: undefined,
    label: 'forecastForReceipt_receiveForecastSearch',
    component: SupplierForecastDashboard,
  },
  {
    router: '/supplier/all-businesses',
    name: undefined,
    label: 'forecastForReceipt_receiveForecastBusiness',
    component: AllBusinessesForSupplierForecast,
  },
];

export const MIN_OF_DISPLAY_FORECAST_MONTH = 3;
export const MAX_OF_DISPLAY_FORECAST_MONTH = 24;
export const DEFAULT_DISPLAY_FORECAST_MONTH = 4;
export const MIN_OF_TARGET_START_MONTH_AGO = -60;
export const MIN_OF_TARGET_END_MONTH_AGO = -57;

export const COLUMN_NAME_FOR_EXPORT_FILE = [
  '仕入先CD',
  '仕入先名',
  '商品CD',
  '商品名',
  '置場CD',
  '置場名',
  'memo1',
  'memo2',
  '容量',
  '内示',
  '販売実績',
] as const;

export const COLUMN_NAME_TO_PROPERTY_FOR_EXPORT_FILE: ReadonlyMap<string, keyof ISupplierForecastExportData> = new Map([
  ['仕入先CD', 'supplierNumber'],
  ['仕入先名', 'supplierName'],
  ['商品CD', 'businessNumber'],
  ['商品名', 'businessName'],
  ['置場CD', 'warehouseNumber'],
  ['置場名', 'warehouse'],
  ['memo1', 'memo1'],
  ['memo2', 'memo2'],
  ['容量', 'package'],
  ['内示', 'SupplierForecasts'],
  ['販売実績', 'SalesResult'],
]);

export const SUUPLIER_FORRECAST_ALL_BUSINESS_TABLE_TYPE = 'supplierForecastAllBusinessTable';
